export interface OverlayStateInterface {
  isOverlayActive: boolean;
}

export const initOverlayStateInterface: OverlayStateInterface = {
  isOverlayActive: false,
};
